import Vitals from "./AppleHealth/components/Vitals";

export default function PatientDashboardVitals() {
  return (
    <div className="appleHealth_container" id="appleHealth-wrapper">
      <div className="tasks_header appleHealth_header">
        <h3 className="pharmacy_header_name">Vitals</h3>
      </div>
      <div className="appleHealth_details">
        <div className="left">
          <Vitals />
        </div>
      </div>
    </div>
  );
}
